import {useMemo} from "react";
import {getFlatRoutes, routesBase} from "v4/data/appRoutes";
import UserService from "api/user/user";
import {useAuthContext} from "v4/contexts/AuthContext";

export default function usePolRouter(isExternal = false, isProtected = false) {
    const {logOut} = useAuthContext();
    let redirectTo = null;

    if (
        (!isExternal && !UserService.isLogged() && window.location.pathname !== routesBase.baseLogin)
        || (isExternal && isProtected && !UserService.isLogged() && !UserService.isSSOOnly())
    ) {
        UserService.setRedirectTo(window.location.pathname + window.location.search);
        redirectTo = `${routesBase.baseLogin}?redirect=${encodeURIComponent(UserService.getRedirectTo())}`;
        logOut();
    }

    if (!isExternal && UserService.isLogged() && window.location.pathname === routesBase.baseLogin) {
        redirectTo = UserService.getRedirectTo() ?? '/';
        UserService.removeRedirectTo();
    }

    const groupedRoutes = useMemo(() => {
        if (redirectTo) return []; // If redirect is set, we don't need to process routes (opti)

        const routes = getFlatRoutes().reduce((acc, route) => {
            if (route.groupCode) {
                const index = acc.findIndex(item => item.groupCode === route.groupCode);
                if (index === -1) {
                    acc.push({
                        groupCode: route.groupCode,
                        path: new Set(route.path),
                        component: route.component,
                        testIsGranted: route.testIsGranted,
                    });
                } else {
                    route.path.forEach(path => acc[index].path.add(path));
                }
            } else {
                acc.push(route);
            }
            return acc;
        }, []);

        return routes.map(route => {
            if (route.groupCode) {
                return {
                    ...route,
                    path: Array.from(route.path),
                }
            }
            return route;
        });
    }, [redirectTo]);

    return {
        groupedRoutes,
        redirectTo,
    }
}
